import { TypographyStyle } from '@forgeglobal/design-framework'

export const gtWalsheim = '"Gt Walsheim", Roboto, sans-serif'

const textDark = '#576573'
const textLight = '#98A9BC'

export const StyleDefaults = {
  borderRadius: 4,
  border: '1px solid #e7ecef',
  textDark,
  color: {
    dark: textDark,
    light: textLight,
    white: '#FFFFFF',
    action: '#F27941',
    warning: '#F93C37',
  },
  palette: {
    blue: {
      light: '#98A9BC',
      dark: '#576573',
    },
    surface: {
      main: '#F8FAFB',
      light: '#FFFFFF',
      dark: '#E7ECEF',
    },
    primary: {
      light: '#F27941',
      main: '#F27941',
      dark: '#D96D3B',
    },
    secondary: {
      light: '#1B998B',
      main: '#1B998B',
      dark: '#178073',
    },
    text: {
      primary: textDark,
      secondary: textLight,
    },
    common: {
      white: '#FFFFFF',
      black: '#000000',
    },
    contrastText: '#fff',
    bid: '#10de1d',
    ask: '#1f62ff',
  },
  tertiaryActionBackground: '#f8fafb',
  secondaryBackgroundColor: '#f8fafb',
  greyBackgroundColor: '#e7ecef',
}

export const h6: Partial<TypographyStyle> = {
  fontFamily: gtWalsheim,
  fontWeight: 500, // GT Walsheim Medium
  fontSize: '20px',
  letterSpacing: 0.25,
}

export const h4: Partial<TypographyStyle> = {
  fontFamily: gtWalsheim,
  fontWeight: 500, // GT Walsheim Medium
  fontSize: '34px',
  letterSpacing: 0.25,
}
